document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('#CscNav');
  if(toggle&&nav){toggle.addEventListener('click',()=>{const open=nav.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});}
  document.querySelectorAll('[data-gallery-thumb]').forEach(button=>{button.addEventListener('click',()=>{const main=document.querySelector('.csc-product-gallery__image');if(!main)return;main.src=button.dataset.image;main.srcset='';main.alt=button.dataset.alt||'';});});
  document.querySelectorAll('[data-variant-select]').forEach(select=>{select.addEventListener('change',()=>{const option=select.options[select.selectedIndex];const form=select.closest('form');const price=document.querySelector('[data-product-price]');const sku=document.querySelector('[data-product-sku]');const button=form?.querySelector('[data-add-to-cart]');const main=document.querySelector('.csc-product-gallery__image');if(price&&option.dataset.price)price.textContent=option.dataset.price;if(sku)sku.textContent=option.dataset.sku||'';if(button){button.disabled=option.dataset.available!=='true';button.textContent=option.dataset.available==='true'?button.dataset.addLabel:button.dataset.soldLabel;}if(main&&option.dataset.image){main.src=option.dataset.image;main.srcset='';}});});
});

// Product gallery thumbnail slider
const initProductThumbSlider=()=>{
  document.querySelectorAll('.csc-product-thumbs').forEach((thumbs)=>{
    if(thumbs.closest('.csc-product-thumbs-shell'))return;
    const shell=document.createElement('div');
    shell.className='csc-product-thumbs-shell';
    const createArrow=(direction)=>{
      const button=document.createElement('button');
      const isPrevious=direction==='previous';
      button.type='button';
      button.className='csc-product-thumbs__arrow csc-product-thumbs__arrow--'+direction;
      button.setAttribute('aria-label',isPrevious?'Previous product images':'Next product images');
      button.innerHTML=isPrevious?'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>':'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
      return button;
    };
    const previous=createArrow('previous');
    const next=createArrow('next');
    thumbs.parentNode.insertBefore(shell,thumbs);
    shell.append(previous,thumbs,next);
    const updateArrows=()=>{
      const maxScroll=thumbs.scrollWidth-thumbs.clientWidth;
      previous.disabled=thumbs.scrollLeft<=1;
      next.disabled=thumbs.scrollLeft>=maxScroll-1;
    };
    const scroll=(direction)=>thumbs.scrollBy({left:direction*thumbs.clientWidth*.8,behavior:'smooth'});
    previous.addEventListener('click',()=>scroll(-1));
    next.addEventListener('click',()=>scroll(1));
    thumbs.addEventListener('scroll',updateArrows,{passive:true});
    thumbs.querySelectorAll('[data-gallery-thumb]').forEach((thumb)=>thumb.addEventListener('click',()=>thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'})));
    if('ResizeObserver' in window)new ResizeObserver(updateArrows).observe(thumbs);
    updateArrows();
  });
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initProductThumbSlider,{once:true});else initProductThumbSlider();
